import { __rest } from "tslib";
import { graphql } from '@apollo/client/react/hoc';
import { flowRight } from 'lodash-es';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { decodeParams } from '@marvelapp/core';
import InviteUsers, { showAddPeopleNotifications, sortFailedInvitesByReason, } from '../InviteUsers';
import { showGenericServerError } from '../ToastContainer';
import { getAddCollaborators, queryMeta } from './queries';
let retry;
export default function (_a) {
    var { entity, itemName, match } = _a, outerProps = __rest(_a, ["entity", "itemName", "match"]);
    const { addMemberMutation } = queryMeta[itemName];
    const isGroupItem = itemName === 'group';
    const searchParams = decodeParams(window.location.search);
    const redirect = (history) => {
        if (searchParams.next) {
            history.replace(searchParams.next);
        }
        else {
            history.replace(match.url.replace('invite', isGroupItem ? 'manage' : 'share'));
        }
    };
    const Wrapped = flowRight(withRouter, graphql(getAddCollaborators(itemName), {
        props({ mutate, ownProps: { itemPk } }) {
            const addCollaborators = (usersToAdd) => {
                return mutate({
                    variables: {
                        // TODO pass in props instead of using match?
                        itemPk: itemPk || Number(match.params.pk),
                        emails: usersToAdd,
                    },
                });
            };
            return {
                addCollaborators,
            };
        },
    }), (Component) => (_a) => {
        var { addCollaborators, history } = _a, props = __rest(_a, ["addCollaborators", "history"]);
        return (React.createElement(Component, Object.assign({ onInviteSuccess: ({ inviteUsersToWorkspace: { succeeded, failed }, setEmails, setIsSendingInvite, setShowFormError, }) => {
                const { domainFailures, alreadyOnAnotherPaidAccountFailures, alreadyOnThisAccountFailures, otherFailures, } = sortFailedInvitesByReason(failed);
                // if some of users fail to be added to company at this point
                // for reasons other than specified, we still want to
                // continue onto adding them to the item
                const usersToAdd = succeeded.concat(otherFailures.map((user) => user.email));
                const triggerFormError = () => {
                    setShowFormError(true);
                    setIsSendingInvite(false);
                };
                retry = () => {
                    triggerFormError();
                    addCollaborators(usersToAdd);
                };
                addCollaborators(usersToAdd)
                    .then(({ data }) => {
                    showAddPeopleNotifications({
                        alreadyOnAnotherPaidAccountFailures,
                        alreadyOnThisAccountFailures,
                        data: data[addMemberMutation],
                        domainFailures,
                        entity: entity || itemName,
                        otherFailures: data[addMemberMutation].failed,
                        redirect: () => redirect(history, match),
                        retry,
                        setEmails,
                        triggerFormError,
                    });
                })
                    .catch(() => {
                    triggerFormError();
                    showGenericServerError({
                        retry,
                        closeOnClick: true,
                    });
                });
            } }, props)));
    })(InviteUsers);
    return React.createElement(Wrapped, Object.assign({ entity: entity, itemName: itemName }, outerProps));
}
